<template>
  <div class="Layout">
    <Navbar />
    <SideMenu
      :active="active"
      :disabled="moving"
      :isOpen="isOpen"
      @openMenu="openMenu"
      @toggleMenu="toggleMenu"
      @setActiveItem="setActiveItem"
      @closeMenu="closeMenu"
    />
    <div class="Layout__Wrapper">
      <router-view />
    </div>
  </div>
</template>

<script>
import { Navbar, SideMenu } from '@/components';

export default {
  name: 'Layout',
  components: {
    Navbar,
    SideMenu,
  },
  data() {
    return {
      active: 'dashboard',
      isOpen: false,
      moving: false,
    };
  },
  methods: {
    onMove() {
      this.moving = true;
      setTimeout(() => {
        this.moving = false;
      }, 500);
    },
    toggleMenu() {
      this.isOpen = !this.isOpen;
      this.onMove();
    },
    closeMenu() {
      if (this.isOpen) {
        this.onMove();
        this.isOpen = false;
      }
    },
    openMenu() {
      if (!this.isOpen) {
        this.onMove();
        this.isOpen = true;
      }
    },
    setActiveItem(active) {
      this.active = active;
    },
  },
};
</script>

<style lang="scss">
.Layout {
  min-height: 100vh;
  color: #181f2d;
  &__Wrapper {
    overflow: auto;
    height: $wrapper-height;
    display: flex;
    justify-content: center;
    right: 0;
    bottom: 0;
    position: absolute;
    width: $wrapper-width-full;
  }
}
</style>
